/* eslint-disable camelcase */
/* eslint-disable max-lines */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable complexity */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/consistent-type-assertions */
/* eslint-disable max-len */
// 先disable，后续模块负责人修改
/**
 * Copyright © 1998 - 2018 Tencent. All Rights Reserved.
 *
 * @author freedeng
 */
import type IFormatLocale from './locale/FormatLocale';
import type IParsedValue from './ParsedValue';
import { DEFAULT_NUMBER_FORMAT } from './format-render-utils/const';
import { getNumberFormatByFormatCode } from './format-render-utils/number-format-utils';
import { getNumberFormatType } from './format-render-utils/format-type-utils';
import en from './locale/en';
import zhCn from './locale/zh-cn';
import PARSED_VALUE_TYPE from './ParsedValueType';
import { CTNumFmt } from './model-pb/ct-num-fmt-sml';
import { NUMBER_FORMAT_TYPE } from './number-format-type';
import i18n from 'i18next';
import Decimal from 'decimal.js';
import dayjs from '@tencent/txdoc_dayjs';

/**
 * 解析模式  目前支持当前类型优先和输入类型优先两种 默认是当前类型优先
 */
export const PARSE_MODE = {
    CURRENT_STYLE_FIRST: 0, // 当前样式优先
    PARSE_STYLE_FIRST: 1, // 识别样式优先
};

export interface ParseResult {
    type: string;
    valueType: PARSED_VALUE_TYPE;
    originValue?: string | number | null;
    numericValue?: string | number;
    value?: string | number | boolean | null;
    formatCode?: string;
    moment?: any;
}

interface ParseOptions {
    value: any,
    numberFormat: CTNumFmt,
    numberFormatType: {
        group: NUMBER_FORMAT_TYPE;
        type: NUMBER_FORMAT_TYPE;
    },
    parseMode: number,
}

/**
 * 判断value是不是日期时间格式的字符串 如果不是返回undifined 如果是 返回一个对象  包含对应的日期时间数 对应type和pattern
 * @param value
 * @param opts
 */
export function parseDateTimeValue(value: any, opts?: any): ParseResult | undefined {
    return parseDate(value, opts);
    // return parseDateTime(value, opts) || parseDate(value, opts) || parseTime(value, opts);
}

/**
 * 处理除了特殊场景外的其他场景 本质上就是排除了一些可以优化性能的场景外，真正要做的识别了。
 * @param options
 * @param opts
 */
function parseOtherValue(options: ParseOptions, opts?: any): ParseResult {
    const result = parsePercentage(options.value, opts)
        // handleConflictType(options.value, opts)
        || parseNumber(options.value, opts)
        // || parseCurrency(options.value, opts)
        // || parseExponential(options.value, opts)
        // || parseThousandNumber(options.value, opts)
        // || parseFractionValue(options.value, opts)
        || parseDateTimeValue(options.value, opts);
    const numericValue = result !== undefined ? result.numericValue : options.value;
    const valueType = result !== undefined ? result.valueType : PARSED_VALUE_TYPE.STRING;
    const { type, formatCode } = handleParseStyleConflict(options, result);

    return {
        value: numericValue,
        type,
        formatCode,
        numericValue,
        valueType,
    };
}

/**
 * 解析普通的数字，不包括千分位分隔符
 * @param value
 */
export function parseNumber(value: string, opts?: any) {
    // 处理圆括号  (9) -> -9
    const numberReg = /^\s*[(（]\s*((\d+(\.\d+)?)|(\.\d+))\s*[)）]\s*$/;
    const matchedAry = numberReg.exec(value);
    if (matchedAry && matchedAry[1]) {
        value = `-${matchedAry[1]}`;
    }

    if (/^\s*[+-]?\s*((\d+(\.\d*)?)|(\.\d+))\s*$/.test(value)) {
        value = value.replace(/\s/g, '');
        value = preHandleNumberStr(value, opts);

        return {
            type: NUMBER_FORMAT_TYPE.NUMBER,
            pattern: '0.00_);[Red](0.00)',
            numericValue: value,
            valueType: PARSED_VALUE_TYPE.NUMBER,
        } as ParseResult;
    }

    return undefined;
}

/**
 * 处理下识别结果和当前单元格样式的格式冲突，决定最终用什么格式
 * @param options
 * @param result
 */
function handleParseStyleConflict(options: ParseOptions, result?: ParseResult) {
    let type; let formatCode;
    if (result && options.parseMode === PARSE_MODE.PARSE_STYLE_FIRST) {
        // 有识别结果 并且当前识别模式是识别样式优先
        const resultGroup = getNumberFormatType(result.formatCode); // 根据格式串获取到对应的group
        if (result.type === NUMBER_FORMAT_TYPE.NUMBER) {
            if (isDateGroupType(options.numberFormatType.group) || options.numberFormatType.group === NUMBER_FORMAT_TYPE.GENERAL) {
                // 识别样式优先时  日期或者常规单元格遇到数值类输入  按常规显示
                type = NUMBER_FORMAT_TYPE.GENERAL;
                formatCode = 'General';
            } else {
                // 其他格式就不能被数字覆盖了
                type = options.numberFormatType.type; // 现有类型
                formatCode = options.numberFormat.formatCode; // 现有format;
            }
        } else if (isDateGroupType(options.numberFormatType.group) && options.numberFormatType.group === resultGroup.group) {
            // 识别结果为日期  而且当前单元格日期结果类型1和识别结果类型一致 以当前样式为准

            type = options.numberFormatType.type; // 现有类型
            formatCode = options.numberFormat.formatCode; // 现有format;
        } else {
            // 其他都以识别结果为准
            type = result.type;
            formatCode = result.formatCode;
        }
    } else if (options.parseMode === PARSE_MODE.CURRENT_STYLE_FIRST && options.numberFormatType.type === NUMBER_FORMAT_TYPE.GENERAL && result && result.type !== NUMBER_FORMAT_TYPE.NUMBER) {
        /** 当前解析模式为原有样式优先 如果原来的格式是常规 同时识别的格式又不是数值的话  那就要用输入识别的格式来渲染 */
        type = result.type;
        formatCode = result.formatCode;
    } else {
        // 其他就用现有格式吧
        type = options.numberFormatType.type; // 现有类型
        formatCode = options.numberFormat.formatCode; // 现有format;
    }
    return {
        type,
        formatCode,
    };
}

/**
 * 根据 value 和 numberFormat 进行解析 输出原值值 解析值 解析结果type 和解析生成的pattern（单元格格式串）
 * @param value 需要解析的原始值
 * @param numberFormat 需要解析的值对应的numberFormat，会参考numberFormat对值进行解析
 * @param opts 额外参数
 */
export function parseValueWithStyle(
    value: any,
    numberFormat: CTNumFmt | null = null,
    opts?: { parseMode?: number; numberFormat?: CTNumFmt },
): IParsedValue {
    const parseMode = opts?.parseMode || PARSE_MODE.CURRENT_STYLE_FIRST; // 解析模式  默认是当前格式优先
    try {
        numberFormat = numberFormat || DEFAULT_NUMBER_FORMAT;
        opts && (opts.numberFormat = numberFormat); // 把numberFormat也设置到opts里面去
        const cellType = getNumberFormatType(numberFormat); // 获取当前单元格的样式类型
        const originValue = value;
        const parseOptions = {
            value,
            numberFormat,
            numberFormatType: cellType,
            parseMode,
        };

        const parseQueue: Function[] = [
            parseOtherValue,
        ];

        let parseResult: ParseResult | undefined; let parseFun;
        /* eslint-disable no-cond-assign  */
        while (parseFun = parseQueue.shift()) {
            parseResult = parseFun.apply(this, [parseOptions, opts]);
            if (parseResult) {
                break;
            }
        }

        let { value: newValue, formatCode } = parseResult || { value };
        if (newValue === -Infinity || newValue === Infinity || !parseResult) {
            // 没有结果  或者数值超出了正常能识别的范围
            newValue = value;
            formatCode = numberFormat?.formatCode;
        }
        numberFormat = getNumberFormatByFormatCode(formatCode);

        if (newValue === null || newValue === undefined) {
            newValue = ''; // 兼容一下异常数据
        }

        return {
            originValue,
            value: newValue,
            numberFormat,
            valueType: parseResult ? parseResult.valueType : PARSED_VALUE_TYPE.STRING, // 默认是string类型
        };
    } catch (error) {
        // 出现错误了 记录下  TODO 增加上报
        console.warn(error);
        let newValue = value;
        if (newValue === null || newValue === undefined) {
            newValue = ''; // 兼容一下异常数据
        }
        return {
            originValue: value,
            value: newValue,
            numberFormat: DEFAULT_NUMBER_FORMAT,
            valueType: PARSED_VALUE_TYPE.STRING,
        } as IParsedValue;
    }
}

/**
 * type是否为日期相关
 * @param type
 */
function isDateGroupType(type: string): boolean {
    switch (type) {
        case NUMBER_FORMAT_TYPE.DATE:
        case NUMBER_FORMAT_TYPE.TIME:
        case NUMBER_FORMAT_TYPE.DATE_TIME:
            return true;
    }
    return false;
}

export function parseFractionValue(value: any, opts?: any): ParseResult | undefined {
    if (opts) {
        // 避免 opts 未使用, 保持和其他 parseXXX 一致的语法
    }
    // const numberFormat = opts && opts.numberFormat;

    const reg = /^\s*[(（]\s*((\d+\s)?(\d+)\/(\d*[1-9]\d*))\s*[)）]\s*$/;
    const matchedAry = reg.exec(value);
    if (matchedAry && matchedAry[1]) {
        value = `-${matchedAry[1]}`;
    }

    const fractionReg = /^([+-]?\s*)(\d+\s)?(\d+)\/(\d*[1-9]\d*)$/;

    const result = value && typeof value === 'string' && value.match(fractionReg);
    // const { group } = getCellNumberFormatType(numberFormat); // 现有类型  分数的识别除了常规  其他都用现有的格式
    if (result && result[3] && result[4]) {
        const molecular = new Decimal(result[3]); // 分子
        const denominator = new Decimal(result[4]); // 分母
        const isNegativeValue = !!(result[1] && '-' === result[1].trim());
        if (molecular.greaterThan(32767) || denominator.greaterThan(32767)) {
            // excel只识别这么大的数字  超过这个就不识别了 分子分母都是
            // 这里直接输入-99999999/2 excel是能识别的  因为他把负号开头当成函数处理了
            return;
        }
        const len = result[4].length;
        let newValue = molecular.div(denominator);
        const hasIntPartValue = !!result[2];
        if (hasIntPartValue) {
            // 整数部分
            const intPartValue = new Decimal(result[2].trim());
            newValue = newValue.plus(intPartValue);
        } else if (denominator.toNumber() === 0 || molecular.toNumber() === 0) {
            // 分母不能为 0 否则识别为常规
            // 没有整数部分的话 分子也不能为 0

            // 历史逻辑, 原因不可考证了, 20220506 修改掉
            // 如果没有整数部分 而且是常规单元格，不进行分数的识别。坑不坑？ 惊不惊喜  意不意外？
            // group === NUMBER_FORMAT_TYPE.GENERAL
            return;
        }
        if (isNegativeValue) {
            // 符号  负号处理下  正号就不用了
            newValue = newValue.mul(-1);
        }

        const formatStr = new Array(len + 1).join('?');
        const formatCode = `# ${formatStr}/${formatStr}`; // 这里识别格式需要根据分子分母来调整  但是目前不清楚具体的规则 自动识别先统一用两位的
        const ret = {
            type: NUMBER_FORMAT_TYPE.FRACTION,
            formatCode,
            numericValue: newValue.toNumber(),
            valueType: PARSED_VALUE_TYPE.NUMBER,
        } as ParseResult;

        return ret;
    }
}

// 重写 moment 解析两位年数的逻辑，比如 19/1/2 到底是解析成 2019/1/12 ，还是 1919/1/12 呢？
// 往前推11年，往后推89年，看落在哪个范围
// 对应的逻辑就是这里控制的，自行搜索文档：https://momentjs.com/docs/
dayjs.prototype.parseTwoDigitYear = function (yearString: string) {
    const currentYear = new Date().getFullYear();
    const upperLimit = currentYear + 11;
    const twoDigitYear = parseInt(yearString, 10);

    if (twoDigitYear + 2000 <= upperLimit) {
        return twoDigitYear + 2000;
    }
    return twoDigitYear + 1900;
};

/**
 * 包裹下时间相关的数字  必须是两位  dayjs这个坑逼 还要我们帮他预处理下 不然他识别不出来
 * @param numStr
 * @param correct 是否要矫正 如果有上下午标记的话  小时位要进行矫正  上午的话时间= (hour%12)  下午的话时间=(hour%12 + 12)
 */
function wrapTimeNum(numStr: string, correct = true, AMPM?: string) {
    if (correct && AMPM !== undefined) {
        if ('P_PM_下午'.split('_').indexOf(AMPM.toUpperCase()) !== -1) {
            // 下午时间
            const correctStr = (Number(numStr) % 12) + 12;
            numStr = correctStr.toString();
        } else {
            const correctStr = (Number(numStr) % 12) + 0;
            numStr = correctStr.toString();
        }
    }
    if (numStr && numStr.length < 2) {
        numStr = `0${numStr}`;
    }
    return numStr;
}

/**
 * 判断日期是否是全阿拉伯数字类型
 * @param date string 日期
 */
function parseDateBase(date: string) {
    let regResult: RegExpMatchArray | null;

    /**
     * 输入为 a-b-c 满足 yyyy/m/d 的型式
     * 这里对齐 excel:
     *  1. a 必须为 4 位数, 且大于 >= 1900 && <= 9999;
     *  2. 1 < b < 12;
     *  3. c 不超过当月最大天数 (1900-2-29 例外)
     * 这里 parseMoment 用来检测得到的日期是否是合法的
     */
    if ((regResult = date.match(/^([0-9]{4})\s*-\s*([0-9]{1,2})\s*-\s*([0-9]{1,2})\s*$/))) {
        const yearNum = Number(regResult[1]);
        if (yearNum >= 1900 && yearNum <= 9999) {
            const todoDates = [{
                dateTime: `${FormatParseEngine.instance().getFullYear(regResult[1])}-${regResult[2]}-${regResult[3]}`,
                targetFormat: 'yyyy/m/d',
            }];
            return FormatParseEngine.instance().parseMoment(todoDates);
        }
    }

    /**
     * 输入为 a-b-c 满足 m/d/yyyy 的型式
     * 这里对齐 excel:
     *  1. c 即 year
     *  2. c 满足 0 <= c <= 99, 1900 <= c <= 9999 的条件
     *  3. a, b 规则满足月份和天数的规范, 同上
     */
    if ((regResult = date.match(/^([0-9]{1,2})\s*-\s*([0-9]{1,2})\s*-\s*([0-9]{1,4})\s*$/))) {
        const yearNum = Number(regResult[3]);
        if ((yearNum >= 0 && yearNum <= 99) || (yearNum >= 1900 && yearNum <= 9999)) {
            const todoDates = [{
                dateTime: `${FormatParseEngine.instance().getFullYear(regResult[3])}-${regResult[1]}-${regResult[2]}`,
                targetFormat: 'm/d/yyyy',
            }];
            return FormatParseEngine.instance().parseMoment(todoDates);
        }
    }

    if ((regResult = date.match(/^([0-9]{0,4})\s*-\s*([0-9]{1,4})\s*$/))) {
        // 对齐 excel 逻辑，只有以下的情况会当成日期来处理
        // 前半部分的数字值在 0-99 区间且长度不超过 2 时
        // 前半部分的数字值大于等于 1900 时
        const leftNum = Number(regResult[1]);
        if ((leftNum >= 0 && leftNum <= 99 && regResult[1].length <= 2) || leftNum >= 1900) {
            // 92/9;  9/15; 13/12; 11/14  A/B 按照 A月B日，B月A日，A年B月 优先级依次识别  不接受第一位为0的情况如0-4 00/4这种
            // date = date.replace(/\s/g, '');
            // dayjs只支持年月日的形式  所以要拼一下年份
            // date = `${FormatParseEngine.instance().getFullYear()}-${regResult[1]}-${regResult[2]}`;
            const todoDates = [
                { dateTime: `${FormatParseEngine.instance().getFullYear()}-${regResult[1]}-${regResult[2]}`, targetFormat: i18n.t('m"月"d"日";@') },
                { dateTime: `${FormatParseEngine.instance().getFullYear()}-${regResult[2]}-${regResult[1]}`, targetFormat: i18n.t('m"月"d"日";@') },
                { dateTime: `${FormatParseEngine.instance().getFullYear(regResult[1])}-${regResult[2]}-1`, targetFormat: 'mmm-yy' },
                // { date: `${regResult[1]}-${regResult[2]}-1`, targetFormat: 'mmm-yy'},
            ];
            return FormatParseEngine.instance().parseMoment(todoDates);
        }
    }

    return false;
}

/**
 * 判断日期是否是中文的类型
 * @param date string 日期
 */
function parseDateChinese(date: string) {
    let regResult: RegExpMatchArray | null;
    if ((regResult = date.match(/^\s*([0-9]{1,4})年([0-9]{1,4})月([0-9]{1,4})日\s*$/))) {
        // 1992年9月1日, 92年9月1日
        // date = date.replace(/\s/g, '');
        const todoDates = [{ dateTime: `${FormatParseEngine.instance().getFullYear(regResult[1])}-${regResult[2]}-${regResult[3]}`, targetFormat: i18n.t('yyyy"年"m"月"d"日";@') }];
        return FormatParseEngine.instance().parseMoment(todoDates);
    }

    if ((regResult = date.match(/^\s*([0-9]{1,4})年([0-9]{1,4})月\s*$/))) {
        // 1992年9月，92年9月
        // date = date.replace(/\s/g, '');
        const todoDates = [{ dateTime: `${FormatParseEngine.instance().getFullYear(regResult[1])}-${regResult[2]}-1`, targetFormat: i18n.t('yyyy"年"m"月";@') }];
        return FormatParseEngine.instance().parseMoment(todoDates);
    }

    if ((regResult = date.match(/^\s*([0-9]{1,4})月([0-9]{1,4})日\s*$/))) {
        // 9月12日
        // date = date.replace(/\s/g, '');
        const todoDates = [{ dateTime: `${FormatParseEngine.instance().getFullYear()}-${regResult[1]}-${regResult[2]}`, targetFormat: i18n.t('m"月"d"日";@') }];
        return FormatParseEngine.instance().parseMoment(todoDates);
    }

    return false;
}

/**
 * 判断日期是否为英文类型
 * @param date string 日期
 */
function parseDateEnglish(date: string) {
    let regResult: RegExpMatchArray | null;
    if ((regResult = date.match(/^([0-9]{1,4})\s*-\s*((JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)[A-Z]*)\s*-\s*([0-9]{1,4})\s*$/i))) {
        // 3-Feb-1992; 2-April-92
        // date = date.replace(/\s/g, '');
        const yearString = FormatParseEngine.instance().getFullYear(regResult[4]);
        const monthString = FormatParseEngine.instance().getMonthNum(regResult[2], 'en');
        const todoDates = [{ dateTime: `${yearString}-${monthString}-${regResult[1]}`, targetFormat: '[$-409]d-mmm-yy;@' }];
        return FormatParseEngine.instance().parseMoment(todoDates);
    }

    if ((regResult = date.match(/^((JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)[A-Z]*)\s*-\s*([0-9]{1,4})\s*$/i))) {
        // Feb-92;  Feb-1992
        // date = date.replace(/\s/g, '');
        const monthString = FormatParseEngine.instance().getMonthNum(regResult[1], 'en');
        const todoDates = [{ dateTime: `${FormatParseEngine.instance().getFullYear()}-${monthString}-${regResult[3]}`, targetFormat: 'd-mmm' }, { dateTime: `${FormatParseEngine.instance().getFullYear(regResult[3])}-${monthString}-1`, targetFormat: 'mmm-yy' }];
        return FormatParseEngine.instance().parseMoment(todoDates);
    }

    if ((regResult = date.match(/^\s*([0-9]{1,4})\s*-\s*((JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)[A-Z]*)\s*$/i))) {
        //  01-Feb;
        // date = date.replace(/\s/g, '');
        const monthString = FormatParseEngine.instance().getMonthNum(regResult[2], 'en');
        const todoDates = [{ dateTime: `${FormatParseEngine.instance().getFullYear()}-${monthString}-${regResult[1]}`, targetFormat: 'd-mmm' }];
        return FormatParseEngine.instance().parseMoment(todoDates);
    }

    return false;
}

/**
 * 判断日期是否是我们产品自定义的那几种类型
 * @param date string 日期
 */
function parseDateCustom(date: string) {
    let regResult: RegExpMatchArray | null;
    if ((regResult = date.match(/^([0-9]{2,4})\s*\.\s*([0-9]{1,2})\s*\.\s*([0-9]{1,2})\s*$/))) {
        // 1992.9.1 这里不能识别类似 1.6.1 或者 1.2.3； 21.1.1 这种才需要识别。这里的正则限制不严格，先把数字位数收缩。
        const todoDates = [{ dateTime: `${FormatParseEngine.instance().getFullYear(regResult[1])}-${regResult[2]}-${regResult[3]}`, targetFormat: 'yyyy"."m"."d' }];
        return FormatParseEngine.instance().parseMoment(todoDates);
    }

    if ((regResult = date.match(/^\s*([0-9]{1,4})年([0-9]{1,4})月([0-9]{1,4})号\s*$/))) {
        // 1992年9月15号
        const todoDates = [{ dateTime: `${FormatParseEngine.instance().getFullYear(regResult[1])}-${regResult[2]}-${regResult[3]}`, targetFormat: i18n.t('yyyy"年"m"月"d"号"') }];
        return FormatParseEngine.instance().parseMoment(todoDates);
    }

    if ((regResult = date.match(/^\s*([0-9]{1,4})月([0-9]{1,4})号\s*$/))) {
        // 9月15号
        const todoDates = [{ dateTime: `${FormatParseEngine.instance().getFullYear()}-${regResult[1]}-${regResult[2]}`, targetFormat: i18n.t('m"月"d"号"') }];
        return FormatParseEngine.instance().parseMoment(todoDates);
    }

    return false;
}

/**
 * 判断字符串是否能识别为日期类型
 * @param {string} date 待识别字符串
 * @returns {*} 能够识别成日期的话，返回对应的类型，格式串和数字值；否则返回 undefined
 */
export function parseDate(date: string, opts?: any): ParseResult | undefined {
    if (typeof date !== 'string') return undefined;
    let numericValue;
    date = date.replace(/\//g, '-');

    const parseResult = parseDateBase(date)
    || parseDateChinese(date)
    || parseDateEnglish(date)
    || parseDateCustom(date);

    // 匹配到了上述 Date 的任意一种
    if (parseResult && parseResult.moment) {
        if (parseResult.moment.year() === 0) {
            return undefined; // 0000/1/1 这种情况识别为常规，同上
        }

        const dateStr = parseResult.moment.format('YYYY-MM-DDTHH:mm:ss.SSS+08:00');
        const temp = datetime2Numeric(dateStr);
        if (temp > 0) {
            numericValue = preHandleNumberStr(temp, opts);
        }
    }

    if (numericValue !== undefined) {
        return {
            type: NUMBER_FORMAT_TYPE.DATE,
            formatCode: parseResult && parseResult.formatCode,
            numericValue,
            valueType: PARSED_VALUE_TYPE.NUMBER,
            moment: parseResult && parseResult.moment,
        };
    }
}

/**
 * 判断是否是基本类型的百分比
 * @param value 百分比
 */
function parsePercentageBase(value: string) {
    if (/^\s*[+-]?\s*((\d{1,3}([,，]?\d{3})*(\.\d*)?)|(\.\d+))\s*%\s*$/.test(value)) {
        // 100% 百分号在后面
        value = value.replace(/\s/g, '');
        return value.substr(0, value.length - 1);
    }

    if (
        // 百分号在前面
        /^\s*%\s*[+-]?\s*((\d{1,3}([,，]?\d{3})*(\.\d*)?)|(\.\d+))\s*$/.test(value) // %-100
        || /^\s*[+-]?\s*%\s*((\d{1,3}([,，]?\d{3})*(\.\d*)?)|(\.\d+))\s*$/.test(value) // -%100
    ) {
        value = value.replace(/\s/g, '');
        if (value.indexOf('+') !== -1) {
            return value.substr(2, value.length);
        }
        if (value.indexOf('-') !== -1) {
            return `-${value.substr(2, value.length)}`;
        }
        return value.substr(1, value.length);
    }

    return false;
}

/**
 * 解析百分比
 * @param value
 * @returns {*}
 */
export function parsePercentage(value: string, opts?: any): ParseResult | undefined {
    // 该方法会被外部 js 所使用，因此要添加对应的防御性编程
    if (typeof value !== 'string') {
        return;
    }

    // 圆括号处理
    const percentageReg1 = /^\s*[(（]\s*((\d{1,3}([,，]?\d{3})*(\.\d*)?)|(\.\d+))\s*%\s*[)）]\s*$/; // (99,123.45%) -> -99,123.45%
    const percentageReg2 = /^\s*[(（]\s*((\d{1,3}([,，]?\d{3})*(\.\d*)?)|(\.\d+))\s*[)）]\s*%\s*$/; // (99,123.45)%  -> -99,123.45%
    const percentageReg3 = /^\s*[(（]\s*%\s*((\d{1,3}([,，]?\d{3})*(\.\d*)?)|(\.\d+))\s*[)）]\s*$/; // (%99,123.45)  -> -99,123.45%
    const percentageReg4 = /^\s*%\s*[(（]\s*((\d{1,3}([,，]?\d{3})*(\.\d*)?)|(\.\d+))\s*[)）]\s*$/; // %(99,123.45)  -> -99,123.45%
    const matchedAry = percentageReg1.exec(value) || percentageReg2.exec(value) || percentageReg3.exec(value) || percentageReg4.exec(value);
    if (matchedAry && matchedAry[1]) {
        value = `-${matchedAry[1]}%`;
    }

    let numericValue;
    let isNeedDot = value.indexOf('.') !== -1;
    numericValue = parsePercentageBase(value);

    if (
        // 识别分数包含百分比的这种串
        /^\s*[(（]\s*((\d+\s)?(\d+)\/(\d*[1-9]\d*)(%))\s*[)）]\s*$/.test(value) // ( 1 1/4%) 或者 (1/4%)
        || /^([+-]?\s*)(\d+\s)?(\d+)\/(\d*[1-9]\d*)(%)$/.test(value) // +1 1/4% 或者  -1 1/4% 或者 -1/4%
    ) {
        const fractionResult = parseFractionValue(value.replace(/%/g, ''), opts);
        if (fractionResult != undefined) {
            // 如果分数能识别 那就赋值 并计算是否需要小数位 否则就不能识别为百分比了  就不用给numericValue赋值了
            numericValue = fractionResult.numericValue;
            isNeedDot = typeof numericValue === 'string' ? numericValue.indexOf('.') !== -1 : false;
        }
    }

    if (typeof numericValue === 'string') {
        numericValue = numericValue.replace(/[,，]/g, '');
        numericValue = preHandleNumberStr(numericValue, opts);
        numericValue = new Decimal(numericValue).div(100)
            .toString(); // 除以 100
        const formatCode = isNeedDot ? '0.00%' : '0%';

        return {
            type: NUMBER_FORMAT_TYPE.PERCENT,
            formatCode,
            numericValue: Number(numericValue),
            valueType: PARSED_VALUE_TYPE.NUMBER,
        };
    }
}

/** 在数字或者字符串转成数字返回前的预处理函数
 * @param {string|number} 预处理数据
 * @return {string}
 */
function preHandleNumberStr(origin: any, opts?: any) {
    // if(!Object.isObject(opts)) opts = {};
    const newNumberStr = handleLongNumber(origin, undefined, opts && opts.toRound);

    // 要注意！！ 这里函数需要精度处理，其他不需要精度处理
    if (opts && opts.toRound) {
        return newNumberStr;
    }

    if (isPrecisionBiggerThan16(origin)) {
        return origin;
    }

    return parseFloat(origin);
}

/**
 * 保留过长数字 15 位精度，分整数部分和小数部分：
 * 1. 整数部分超过 15 位，整数超出部分以 0 替代，小数部分截取
 * 2. 整数部分没有超过 15 位，整数和小数加起来总位数保留不超过 15 位，超出部分截取
 + @param {string|number} origin 原始数字字符串，接受正负数和科学记数
 * @param {number} totalLen 保留的最长位数
 * @param {boolean} toRound 是否四舍五入，如果不为 true 到话，直接舍弃超出位数
 * @return {string} 返回处理后的数字字符串，不能经过 parseFloat 之后再调用这个函数，因为比如 parseFloat('9999999999999999')
 *  之后传进来的值是 10000000000000000 就已经是错的了，再怎么截取还是错的
 */
export function handleLongNumber(origin: string, totalLen: number | undefined, toRound: boolean | undefined) {
    totalLen = totalLen || 15;
    const temp = parseFloat(origin);
    if (isNaN(temp)) {
        return origin;
    }
    origin = `${origin}`;
    origin = origin.trim();
    let suffix = '';
    const eIndex = origin.indexOf('e') === -1 ? origin.indexOf('E') : origin.indexOf('e');
    if (eIndex !== -1) {
        suffix = origin.slice(eIndex);
        origin = origin.slice(0, eIndex);
    }
    const strArray = origin.split('');
    let intCount = 0;
    let decCount = 0;
    let dotBegin = false;
    for (let i = 0; i < strArray.length; i++) {
        const c = strArray[i];
        if (c === '-' && i === 0) {
            continue;
        } else if (c === '.') {
            dotBegin = true;
            if (intCount >= totalLen) strArray[i] = '';
        } else if (!isNaN(parseInt(c, 10))) {
            if (!dotBegin) {
                intCount += 1;
                if (intCount > totalLen) {
                    strArray[i] = '0';
                }
                if (toRound === true && intCount === totalLen + 1 && parseInt(c, 10) >= 5) {
                    strArray[i - 1] = `${parseInt(strArray[i - 1], 10) + 1}`;
                }
            } else {
                decCount += 1;
                if (intCount >= totalLen || intCount + decCount > totalLen) {
                    strArray[i] = '';
                }
                if (toRound === true && intCount + decCount === totalLen + 1 && parseInt(c, 10) >= 5) {
                    const preIndex = strArray[i - 1] === '' ? i - 2 : i - 1;
                    const d = parseInt(strArray[preIndex], 10);
                    if (!isNaN(d)) {
                        strArray[preIndex] = `${d + 1}`;
                    }
                }
            }
        } else {
            strArray[i] = '';
        }
    }
    return strArray.join('') + suffix;
}

/**
 * 判断数字 value 的精度是否超过了 16，因为 parseFloat 最多支持 16 位精度
 * @param length
 */
export function isPrecisionBiggerThan16(value: string) {
    if (typeof value === 'number') {
        // 如果本来就是数字的话，自然不会超 16 位精度，那就不需要判断了
        return false;
    }
    if (!value) return false;
    const dot = value.indexOf('.');
    if (dot !== -1) {
        // 将小数转换为整数，然后再统一算精度
        value = value.substr(0, dot) + value.substr(dot + 1, value.length);
    }
    value = value.replace(/[+-]/, ''); // 处理正负号
    value = value.toUpperCase();
    const exp = value.indexOf('E');
    if (exp !== -1) {
        // 将科学记数 E 后面的部分去掉
        value = value.substr(0, exp);
    }
    const regResult = value.match(/^[0]*([1-9]([0-9]*[1-9])?)[0]*$/);
    if (regResult && regResult[1].length > 16) {
        return true;
    }
    return false;
}

/**
 * 将任意日期字符串转换为数字
 * @param fullDate 日期字符串，需要符合 YYYY-M-DTHH:mm:ss.SSS+08:00 举例子 1900-1-1T01:02:03.000+08:00  不符合这种格式的，难以保证解析正确
 * @param {Object} option 选项
 * @param option.need_1900_2_29 是否需要对齐 excel 的 1900-2-29 的 bug，20211922 改为不默认对齐 excel, 取 false
 */
// eslint-disable-next-line camelcase
export const datetime2Numeric = function (
    fullDate: string,
    {
        need_1900_2_29 = false,
    } = {},
): number {
    let fullDateImpl = fullDate;
    let is1900_2_29 = false;
    if (/1900-0?2-29/.test(fullDate)) {
        // 推后1天, 使得 web 日期系统可以和 1900-2-28 连续
        fullDateImpl = fullDate.replace('1900-2-29', '1900-3-1');
        is1900_2_29 = true;
    }

    const currentTimeStamp = Date.parse(fullDateImpl);
    const timeStamp19700101 = Date.parse('1970-01-01T00:00:00.000+08:00');
    const timeStamp = currentTimeStamp - timeStamp19700101;

    // 25568, 1900-01-01 到 1970-01-01 的天数
    let normalDayBias = (timeStamp / (1000 * 3600 * 24)) + 25568;

    /*
     * 适配 1900/2/29 的情况下需要在 1900/3/1(60) 后加多一天
     * 1900/2/28 [59, 60) -> [59, 60)
     * 1900/2/29 [60, 61) -> [60, 61)
     * 1900/3/1 [60, 61) -> [61, 62)
     */
    if (need_1900_2_29) {
        normalDayBias = (normalDayBias >= 60 && !is1900_2_29) ? normalDayBias + 1 : normalDayBias;
    }

    return normalDayBias;
};

export class FormatParseEngine {
    supportLocales: Map<string, IFormatLocale> = new Map<string, IFormatLocale>();

    private static _instance: FormatParseEngine = new FormatParseEngine();
    static instance() {
        return FormatParseEngine._instance;
    }


    constructor() {
        this.supportLocales.set('en', en);
        this.supportLocales.set('zh-cn', zhCn);
    }

    getFullYear(yearString?: string) {
        if (!yearString) {
            // 如果不传，就返回当前年份
            return new Date().getFullYear()
                .toString();
        } if (yearString.length >= 4) {
            return yearString;
        }
        const currentYear = new Date().getFullYear();
        const upperLimit = currentYear + 11;
        const twoDigitYear = parseInt(yearString, 10);

        if (twoDigitYear + 2000 <= upperLimit) {
            return twoDigitYear + 2000;
        }
        return twoDigitYear + 1900;
    }

    getMonthNum(monthString: string, locale: string) {
        let monthNum = 0;
        if (monthString.length < 3) {
            // 最少要3位
            return monthNum;
        }
        const localeObject = this.supportLocales.get(locale);
        if (localeObject) {
            monthString = monthString.toUpperCase();
            for (let i = 0; i < localeObject.months.length; i++) {
                if (localeObject.months[i].startsWith(monthString)) {
                    // 长度大于3 而且是是日期英文写法开头
                    monthNum = i + 1;
                    break;
                }
            }
        }
        return monthNum;
    }

    parseMoment(toBeParseDateTimes: any[]) {
        for (let i = 0; i < toBeParseDateTimes.length; i++) {
            const toBeParseDateTime = toBeParseDateTimes[i];
            const { dateTime } = toBeParseDateTime;

            const moment = dayjs(dateTime);
            if (moment.isValid()) {
                return {
                    moment,
                    formatCode: toBeParseDateTime.targetFormat,
                };
            }
        }
    }
}
// 设置全局语言
// moment.updateLocale('en', LOCAL_VALUE.EN);
// // if(moment.locale('zh-cn') !== 'zh-cn'){
// moment.updateLocale('zh-cn', <any>LOCAL_VALUE.CN);
// // }
